import { render, staticRenderFns } from "./ProductRowList.vue?vue&type=template&id=a5953180&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ProductRowList.vue?vue&type=script&lang=ts&"
export * from "./ProductRowList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductRowList.vue?vue&type=style&index=0&id=a5953180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5953180",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
